import { Div, StyledHtml, Wrapper } from './styles'
import { Header, IllustrationHouseComposition, Text } from '@bbl-digital/snorre'
import { useSelector } from 'react-redux'
import { getBbl, getBblDisplayNames } from 'shared/store/bbl'
import { getCustomtext } from 'shared/store/customtexts/selectors'
import { GUIDE_WELCOMESTEP_TEXT } from 'shared/constants/customtexts'
import React from 'react'

const StableHtml = React.memo(
  ({ text }: { text?: string }) => {
    const htmlContent = React.useMemo(
      () => (
        <StyledHtml
          removeMargins
          text={text}
          externalLinks
          whiteSpace="normal"
          allowVideo
        />
      ),
      [text]
    )

    return htmlContent
  },
  (prev, next) => {
    // Strict comparison to prevent unnecessary re-renders
    return prev.text === next.text
  }
)

const WelcomeStep = () => {
  const { portal } = useSelector(getBblDisplayNames)
  const customText = useSelector(getCustomtext(GUIDE_WELCOMESTEP_TEXT))
  const { data: bbl } = useSelector(getBbl)

  return (
    <Wrapper>
      <IllustrationHouseComposition height="123px" />
      <Header level={3}>Velkommen til {portal}!</Header>
      {customText?.isCustomized && customText.text ? (
        <StableHtml text={customText.text} />
      ) : (
        <Div>
          <Text paragraph align="center">
            Velkommen som ny bruker av {portal} til{' '}
            {bbl?.shortName || bbl?.name}.
            <br />
            Naviger deg enkelt rundt ved å benytte hovedmenyen som ligger på
            venstre side, som er temabasert. Under det enkelte hovedmenypunkt
            vil du finne et utvalg av menyer og funksjoner, som vi håper at
            styret finner nyttig.
            <br />
            <br />
            Bli med på en omvisning av navigasjon og funksjoner: Om du ønsker å
            hoppe over dette trykker du på "Ikke nå".
          </Text>
        </Div>
      )}
    </Wrapper>
  )
}

export default WelcomeStep
